exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CategoryQuestion .qbm-accordion-content__item{display:flex;justify-content:space-between;padding-top:10px;padding-bottom:5px}.CategoryQuestion .qbm-accordion-content__item .action{display:flex;flex-direction:row;align-items:center;flex-wrap:nowrap;min-width:45px}.CategoryQuestion .qbm-accordion-content__item .action .text{margin-right:10px;color:#11b2ff;font-size:14px;font-weight:500}.CategoryQuestion .qbm-accordion-content__item .action i{color:#00adff}.CategoryQuestion .qbm-accordion-content__item .action a{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Question/components/Category/style.scss
// module id = 5216
// module chunks = 0